var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('range-slider',{staticClass:"slider",attrs:{"min":"0","max":_vm.nStep,"step":"1"},model:{value:(_vm.sliderValue),callback:function ($$v) {_vm.sliderValue=_vm._n($$v)},expression:"sliderValue"}})}
var staticRenderFns = []

export { render, staticRenderFns }